import { Injectable } from '@angular/core';
import { SessionsService } from './sessions.service';

@Injectable({
  providedIn: 'root' 
})
export class UtilsService {  
  public homeSearch:any="";
  public homeBodyType:any="";
  public homeBrandType:any="";
  constructor(private sessionService:SessionsService) { }

/** headerAuthResponse function used to handle header auth response */
  headerAuthResponse(result:any)
  {
    //console.log("in headerAuth");
    if(result.status==="success") 
    {
      let array=result.header_auth_credentials;
      for(let i=0;i<array.length;i++)
    {
      this.sessionService.setSession('auth_user',array[i].username);
      this.sessionService.setSession('auth_pass',array[i].password);     
    }
    }
    else
    {
      alert("Something went wrong !");
    }    
  }

  

  trimming_fn(x) {  
    x=x+"";  
    return x ? x.replace(/^\s+|\s+$/gm, '') : '';    
   }    

}
